import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
const EditDealIndex = () => {
  const navigate = useNavigate();
  const { dealId } = useParams();
  useEffect(() => {
    navigate(`/deals/${dealId}/edit/${ROUTE_KEYS.EDIT_DEAL_DETAILS}`, {
      replace: true
    });
  }, []);
  return <div />;
};

export default EditDealIndex;
